import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import _ from 'underscore';

import MapView from './MapView';
import BookmarkButton from './BookmarkButton';
import BreadCrumbs from './BreadCrumbs';
import AbendingForm from './AbendingForm';
import LinkedLbsSources from './LinkedLbsSources';

import config from './../config';

class BaerView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/baeir/';

		this.state = {
			loading: false
		};
	}

	componentDidMount() {
		if (this.props.match && this.props.match.params.id) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.match.params.id != prevProps.match.params.id) {
			this.fetchData();
		}
	}

	fetchData() {
		let params = [];

		this.setState({
			loading: true
		});

		fetch(this.url+this.props.match.params.id+'/')
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json,
					mapListData: json.ornefni ? _.compact(json.ornefni.sort().map((ornefni) => {
						if (ornefni.uuid) {
							return  {
								id: ornefni.id,
								label: ornefni.ornefni,
								type: 'lmi_ornefni',
								uuid: ornefni.uuid
							}
						}
					})) : [],
					featureData: json.ornefni ? _.compact(json.ornefni.map((ornefni) => ornefni.uuid)) : [],
					loading: false

				});
			}.bind(this));
	}

	render() {
		let item = this.state.data;

		return (
			<div className={'row boxes'}>

				<div className={'col col-12'}>
					<div className={'column-content'+(this.state.loading ? ' loading' : '')}>
						{
							item &&
							<React.Fragment>

								<BreadCrumbs path={[
									item.sveitarfelag ? {
										path: '/sveitarfelog/'+item.sveitarfelag.id,
										title: item.sveitarfelag.nafn
									} : item.sysla ? {
										path: '/syslur/'+item.sysla.id,
										title: item.sysla.nafn
									} : null,
									{
										path: item.id,
										title: item.baejarnafn
									}
								]} />

								<h3>{item.baejarnafn}</h3>
								<hr/>

								<div className="row">

									<div className={'col col-12 col-md-'+((!item.lat || !item.lng) ? '10' : '5')}>
										<p>
											{
												item.sysla &&
												<React.Fragment><strong>Sýsla:</strong> <Link className="badge badge-light" to={'/syslur/'+item.sysla.id}>{item.sysla.nafn}</Link> </React.Fragment>
											}
											{
												item.hreppur &&
												<React.Fragment><strong>Hreppur:</strong> <Link className="badge badge-light" to={'/hreppur/'+item.hreppur.id}>{item.hreppur.nafn}</Link> </React.Fragment>
											}
											{
												item.sveitarfelag &&
												<React.Fragment><strong>Sveitarfélag:</strong> <Link className="badge badge-light" to={'/sveitarfelog/'+item.sveitarfelag.id}>{item.sveitarfelag.nafn}</Link></React.Fragment>
											}
											{
												item.tegund &&
												<React.Fragment><br/><br/><strong>Tegund staðsetningar:</strong> {item.tegund.tegund}</React.Fragment>
											}
										</p>
										<br/>

										{
											item.skrar && item.skrar.length > 0 &&
											<React.Fragment>
												<h5>Skjöl</h5>

												<table className="table">
													<thead>
														<tr>
															<th>Titill</th><th></th><th></th>
														</tr>
													</thead>
													<tbody>
														{
															item.skrar.map((skra, index) => {
																return <tr key={index}>
																	<td><Link to={'/ornefnaskra/'+skra.id}>{skra.titill}</Link>{skra.artal_skrar != null ? ' ('+skra.artal_skrar+')': ''}</td>
																	<td>{skra.tegund}</td>
																	<td><BookmarkButton title={skra.titill}
																		id={skra.id}
																		baer={item.baejarnafn}
																		baer_id={item.id}
																		type={'skra'}
																		className="small" /></td>
																</tr>
															})
														}
													</tbody>
												</table>
											</React.Fragment>
										}

										{
											item.greinar && item.greinar.length > 0 && <React.Fragment>
												<h5>Greinar</h5>

												<table className="table">
													<thead>
														<tr>
															<th>Titill</th><th>Höfundur</th>
														</tr>
													</thead>
													<tbody>
														{
															item.greinar.map((item, index) => <tr>
																<td><Link to={'/grein/'+item.article.id}>{item.article.title}</Link></td><td>{item.article.authors.length > 0 ? item.article.authors[0].nafn : ''}</td>
															</tr>)
														}
													</tbody>
												</table>
											</React.Fragment>
										}

										{/*
										<h5>Einstaklingar</h5>

										<table className="table">
											<thead>
												<tr>
													<th>Nafn</th><th>Fæðingardagur</th><th>Tengsl</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td><Link to="/einstaklingur/1">Jón Jónsson</Link></td><td>1910</td><td>Fæðingarstaður</td>
												</tr>
												<tr>
													<td><Link to="/einstaklingur/2">Sigurður Jónsson</Link></td><td>1925</td><td>Heimili</td>
												</tr>
											</tbody>
										</table>
										*/}

										<AbendingForm entityId={item.id} entityType="baer" entityName={item.baejarnafn}>
											<h3>Senda ábendingu</h3>
											<p>Senda ábendingu varðandi bæinn <strong>{item.baejarnafn}</strong>.</p>
										</AbendingForm>

									</div>

									{
										item.lat && item.lng &&
										<div className="col col-12 col-md-7">
											<MapView mapData={
												[
													{
														id: item.id,
														label: item.baejarnafn,
														district: (item.hreppur ? item.hreppur.nafn+', ' : '')+item.sysla.nafn,
														type: 'farm',
														tegund: item.tegund ? item.tegund : null,
														latLng: [item.lat, item.lng]
													}
												]
											}
											overlayListData={this.state.mapListData}
											overlayVisible={true}
											featureData={this.state.featureData} />
										</div>
									}

								</div>
								{
											item.lbs_lykill && <LinkedLbsSources current="nafnid" lbs_key={item.lbs_lykill} />
										}

							</React.Fragment>
						}
					</div>
				</div>

			</div>
		);
	}
}

export default withRouter(BaerView);



// WEBPACK FOOTER //
// ./src/components/BaerView.js